<div class="section-bc w-100 p-4 d-flex flex-wrap mt-3 mb-1 rounded rounded-lg">
  <div class="col-12 col-xl-10">
    <h6 class="text-primary font-weight-bold">{{'CONTACT.TITLE' | translate}}</h6>
    <div class="">{{'CONTACT.SUBTITLE' | translate}}</div>
  </div>
  <div class="col">
    <div class="row justify-content-end align-items-center mt-2">
      <button class="btn btn-primary btn-block">{{'CONTACT.BUTTON' | translate}}</button>
    </div>
  </div>
</div>
